import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";

export const GreenSwitch = withStyles({
    switchBase: {
      '&$checked': {
        color: 'rgb(4, 180, 105)',
      },
      '&$checked + $track': {
        backgroundColor: 'rgb(4, 180, 105)',
      },
    },
    checked: {},
    track: {},
  })(Switch)